import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ui, uiA, uiFormRow, uiCheckbox, rsSelect } from 'envy-ui';
import { Color } from '../inputControls';
import { backgroundBlendModes } from '../../page/homepage';
import { uiInputText } from 'envy-ui/lib/from-dictionary/block_name';

export default function SubSection({ label: pLabel, onClick, customClass = '', style = {} }) {
  let icon;
  let label;
  let isConfig = false;
  let Config;

  const [isConfigVisible, setConfigVisible] = useState(false);

  const onToggleConfig = () => setConfigVisible(!isConfigVisible);
  const BannerConfig = () => {
    const options = backgroundBlendModes;

    return (
      <div {...ui([uiA`f m-top f-a-center w-100%`])}>
        <span {...ui([uiFormRow``, uiA`f m-top m-left m-right-auto f-1-0-auto`])}>
          <input type="checkbox" checked onChange={() => null} {...ui([uiCheckbox`--check`, uiA`m-right`])} />
          <span {...ui([uiFormRow`__label --free`, uiA`m-right-auto`])}>Enable Banner Image</span>
        </span>
        <span {...ui([uiFormRow``, uiA`f m-x m-bottom`])}>
          <span {...ui([uiFormRow`__label --free`])}>Blend Mode</span>
          <Select value={options[0]} options={options} styles={rsSelect().styles} theme={rsSelect().theme} {...ui([uiA`m-right`])} />
          <Color
            onChange={'color.onChange'}
            color={'color.color'}
            position={'color.position'}
            tooltip={'color.tooltip'}
            tooltipPosition={'color.tooltipPosition'}
            alphaOnly
          />
        </span>
      </div>
    );
  };

  const BannerTextConfig = () => (
    <span {...ui([uiA`f f-a-center m f-1-0-auto`])}>
      <label {...ui([uiFormRow``, uiA`m-bottom-none m-right-auto`])}>
        <span {...ui([uiFormRow`__label --free`, uiA` font-weight-normal`])}>Decoration</span>
        <select {...ui([uiInputText``, uiA`font-weight-normal`])}>
          <option value="">No Decoration</option>
          <option value="stripe">Stripe</option>
          <option value="border">Border</option>
        </select>
      </label>
      <div {...ui([uiA`h-20`])}>
        <Color
          onChange={'color.onChange'}
          color={'color.color'}
          position={'color.position'}
          tooltip={'color.tooltip'}
          tooltipPosition={'color.tooltipPosition'}
        />
      </div>
    </span>
  );

  switch (pLabel) {
    case 'logo':
      label = 'Upload';
      break;
    case 'setBannerBackground':
      icon = <FontAwesomeIcon icon={['fal', 'tint']} />;
      label = 'Set Background Color';
      break;
    case 'bannerImage':
      icon = <FontAwesomeIcon icon={['fal', 'upload']} />;
      label = 'Banner Image';
      // isConfig = true;
      // Config = BannerConfig;
      break;
    case 'bannerText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Banner Text';
      // isConfig = true;
      // Config = BannerTextConfig;
      break;
    case 'newsFeed':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      break;
    case 'introText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Intro Content';
      break;
    case 'featureImage':
      icon = <FontAwesomeIcon icon={['fal', 'upload']} />;
      label = 'Feature Image';
      break;
    case 'textInput':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Feature Text';
      break;
    case 'featureText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Feature Text';
      break;
    case 'measureText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Measure Text';
      break;
    case 'subText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Sub Content';
      break;
    case 'footerText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Footer Text';
      break;
    case 'planNodeTitle':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Title';
      break;
    case 'planNodeDescription':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Description';
      break;
    case 'latestUpdate':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Latest Update';
      break;
    case 'additionalText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Additional Text';
      break;
    case 'additionalBottomText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Additional Text';
      break;
    case 'additionalMiddleText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Additional Text';
      break;
    case 'additionalUpperMiddleText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Additional Text';
      break;
    case 'subPlanContentLabels':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Sub Plan Content Labels';
      break;
    case 'measureTitle':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Measure Title';
      break;
    case 'measureDescription':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Measure Description';
      break;
    case 'measureComment':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Comment';
      break;
    case 'visualText':
      icon = <FontAwesomeIcon icon={['fal', 'edit']} />;
      label = 'Visual Text';
      break;
    case 'commonBanner':
      label = 'Banner';
      break;
    default:
      break;
  }

  return (
    <>
      <div {...ui([uiA`f f-a-center transition-none m-bottom-none:${isConfigVisible}`, `layout-content ${customClass}`])} style={style}>
        <div {...ui([uiA`f-1-0-auto`, `layout-content-info`])} onClick={onClick} onKeyPress={() => {}} role="button" tabIndex={0}>
          {icon}
          <span className="layout-content-label">{label}</span>
        </div>
        {/* {isConfig && (
          <>
            <span {...ui([uiA`h-min-20 w-min-1 w-1 border-left-panel m-x-small`])} />
            <div {...ui([uiA`m-x-small`])} onClick={onToggleConfig} onKeyPress={() => {}} role="button" tabIndex={0}>
              <FontAwesomeIcon icon={['fal', 'sliders-h']} />
            </div>
          </>
        )} */}
      </div>
      {/* {isConfigVisible && (
        <div {...ui([uiA`f color-bg-gallery border-top-light m-bottom`])}>
          <Config />
        </div>
      )} */}
    </>
  );
}

SubSection.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  customClass: PropTypes.string,
};
